import {ScriptsProvider} from '../providers/scriptsProvider';
import {ConfigProvider} from '../config/configProvider';

class GoogleOptimize
{
    constructor() {
        this.optimizeCode = ConfigProvider.get('google-optimize');
        this.scriptSource = 'https://www.googleoptimize.com/optimize.js?id=' + this.optimizeCode;

        if (this.optimizeCode && !ScriptsProvider.has(this.scriptSource)) {
            ScriptsProvider.add(this.scriptSource);
        }
    }
}

export {GoogleOptimize};
